export default [

     {
          path: '/staff',
          name: 'Staff',
          component: () => import("@/views/Page/Staff/Staff.vue"),
           meta: {
               title: '#Default# | Staff',
          },
     }
];